import { Component, Injector, OnInit } from '@angular/core';
import { BaseComponent } from 'src/app/shared/baseComponent';

@Component({
  selector: 'app-activities',
  templateUrl: './activities.component.html',
  styleUrls: ['./activities.component.css']
})
export class ActivitiesComponent extends BaseComponent implements OnInit {
  constructor(injector: Injector) { super(injector) }
  logs: any = []
  loginlogs: any = []
  scenariologs: any = []
  overview: any = []
  scenarios: any = []
  organizations: any = []
  orgs: any = [] //those orgs with records
  org: any = {} //selected org
  overviewgps: any = []
  users: any = []
  strselectedDate = ""
  showModalWindow = false

  async ngOnInit() {
    this.loader.show()
    let dt = new Date()
    const newDate = new Date(dt.getFullYear(), dt.getMonth() - 1, dt.getDate());
    this.strselectedDate = newDate.toISOString().slice(0, 10)

    this.organizations = await this.db.get('organization', "getorganizations")
    this.users = await this.db.get("authenticate", "getallusers")
    this.users.forEach((u: any) => {
      u.name = u.firstName + " " + u.lastName
      u.orgname = ""
      let org = this.organizations.find((o: any) => o.id == u.organizationId)
      if (org != null) u.orgname = org.name
    })

    this.scenarios = await this.db.get('scenario', "getscenarios")

    this.loader.hide()
  }
  async getData() {
    this.organizations.forEach((o: any) => {
      o.show = false
      o.logins = 0
      o.scenarioupdates = 0
      o.gps = 0
      o.beacons = 0
    })
    this.orgs = []
    await this.getLoginInfos()
    await this.getScenarioInfos()
    await this.getGPSInfos()
    await this.getBeaconInfo()

    this.organizations.forEach((o: any) => {
      if (o.show) this.orgs.push(o)
    })
  }

  async getLoginInfos() {
    this.loginlogs = await this.db.get("authenticate", "GetLoginActivities", { dt: this.strselectedDate })
    this.loginlogs.forEach((l: any) => {
      l.orgname = ""
      let user = this.users.find((u: any) => u.email == l.description)
      if (user != null) l.orgname = user.orgname
      let org = this.organizations.find((o: any) => o.name == l.orgname)
      if (org != null) {
        org.logins += 1
        org.show = true
      }
    })


  }
  async getGPSInfos() {
    this.overviewgps = await this.db.get("gpslog", "GetGPSLogsOverviewByDate", { dt: this.strselectedDate });
    this.overviewgps.forEach((over: any) => {
      let scen = this.scenarios.find((x: any) => x.id == over.id)
      over.scenarioname = ""
      over.organizationname = ""
      over.date = over.firstRecord.dateCreated  //so you can sort 
      if (scen != null) {
        over.scenarioname = scen.name

        let org = this.organizations.find((x: any) => x.id == scen.organizationId)
        if (org != null) {
          over.organizationname = org.name
          org.gps += 1
          org.show = true
        }
      }
    })
  }
  async getBeaconInfo() {
    this.overview = await this.db.get('beaconlog', "getoverviewbydate", { dt: this.strselectedDate })

    this.overview.forEach((o: any) => {
      o.organizationname = "undefined"
      let scen = this.scenarios.find((x: any) => x.id == o.scenarioId)
      if (scen != null) {
        o.organizationname = this.lookup(scen.organizationId, this.organizations)
      }
      let org = this.organizations.find((x: any) => x.name == o.organizationname)
      if (org != null) {
        org.beacons += 1
        org.show = true
      }

    })
  }
  async getScenarioInfos() {
    this.scenariologs = await this.db.get("authenticate", "GetScenarioActivities", { dt: this.strselectedDate })
    this.scenariologs.forEach((l: any) => {
      let s = l.description
      let ss: string[] = s.split("|");
      let aspnetid = ss[0]
      let user = this.users.find((x: any) => x.id == aspnetid)
      l.username = user == null ? "not found" : user.firstName + " " + user.lastName
      l.scenarioid = ss[1]
      l.scenario = ss[2]
      let organizationId = user.organizationId
      this.organizations.forEach((o: any) => {
        if (o.id == organizationId) {
          o.show = true
          o.scenarioupdates += 1
        }
      })
    })
  }

  showModal(org: any) {
    this.org = org
    this.org.beaconLogCount = 0
    this.org.lastBeaconLogDate = ""
    this.overview.forEach((o: any) => {
      if (o.organizationname == this.org.name) {
        if (this.org.lastBeaconLogDate != "") {
          if (this.org.lastBeaconLogDate < o.lastDate) {
            this.org.beaconLogCount = o.count
            this.org.lastBeaconLogDate = o.lastDate
          }
        }else{
          this.org.beaconLogCount = o.count
          this.org.lastBeaconLogDate = o.lastDate
        }
      }
    })
    this.org.gpsLogCount = 0
    this.org.lastGpsLogDate = ""
    this.overviewgps.forEach((g:any)=>{
      if (g.organizationname == this.org.name) {
        if (this.org.lastGpsLogDate != "") {
          if (this.org.lastGpsLogDate < g.lastDate) {
            this.org.gpsLogCount = g.count
            this.org.lastGpsLogDate = g.lastDate
          }
        }else{
          this.org.gpsLogCount = g.count
          this.org.lastGpsLogDate = g.lastDate
        }
      }
    })

    this.org.lastLoginDate = ""
    this.loginlogs.forEach((l:any)=>{
      if (l.orgname == this.org.name) {
        if (this.org.lastLoginDate == ""){
          this.org.lastLoginDate = l.dateCreated
        }
      }
    })


    this.showModalWindow = true
  }
}
